module.exports = __webpack_public_path__ + "static/media/font-awesome-flag.0d74473c.svg";